import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import {
  CardActionArea,
  Checkbox,
  checkboxClasses,
  styled,
  Button
} from "@mui/material";

const CardHeading = styled(Typography)({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "24px",
  lineHeight: "150%",
  letterSpacing: "0.01em",
  color: "#1A1824",
});

const CustomButton = styled("a")({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "150%",
  letterSpacing: "0.015em",
  textDecorationLine: "underline",
  color: " #2B817B",
});
const CardSubHeading = styled(Typography)({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  letterSpacing: "0.015em",
  color: "#545359",
});
export default function ContentCard({item}) {
    const {heading,subHeading,onChecked,onClickView} = item
  return (
    <Card sx={{ maxWidth: 318, boxShadow: "none" }}>
      <CardActionArea>
        <CardMedia
          component="div"
          style={{
            height: "140px",
            alignItems: "flex-start",
            justifyContent: "flex-end",
            display: "flex",
          }}
          image="https://thumbs.dreamstime.com/b/asian-food-background-various-ingredients-rustic-stone-top-view-vietnam-thai-cuisine-148762904.jpg"
          alt="green iguana"
        >
          <Checkbox
            size="small"
            labelStyle={{ color: "white" }}
            iconStyle={{ color: "white" }}
            sx={{
              [`&, &.${checkboxClasses.checked}`]: {
                color: "#fff",
                fill: "#fff",
              },
            }}
            onChange={(e)=>{
                onChecked(e.target.value)
            }}
          />
        </CardMedia>
        <CardContent>
          <CardHeading gutterBottom variant="h5" component="div">
            {heading}
          </CardHeading>
          <CardSubHeading variant="body2" color="text.secondary">
            {subHeading}
          </CardSubHeading>
          <CustomButton onClick={onClickView}>View Details</CustomButton>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
